import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getAllListings = createAsyncThunk(
  "Listings/getAllListings",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/transactions/listings?pageNumber=${data.pageNumber}&search=${data.search}&is_rental=${data.is_rental?data.is_rental:data.is_rental===false?data.is_rental:""}&pageSize=${data.pageSize}&sortBy=${data.sortBy || ''}&sortOrder=desc&status=${data.status || 'all'}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return { data: resp.data?.data, reset: data.reset };
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

